/**
 * Environment validation – fail fast in development if required env vars are missing.
 */

const REQUIRED_ENV_KEYS = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
] as const

export interface Env {
  VITE_FIREBASE_API_KEY: string
  VITE_FIREBASE_AUTH_DOMAIN: string
  VITE_FIREBASE_PROJECT_ID: string
  VITE_FIREBASE_STORAGE_BUCKET: string
  VITE_FIREBASE_MESSAGING_SENDER_ID: string
  VITE_FIREBASE_APP_ID: string
}

function getEnv(key: string): string {
  const value = import.meta.env[key]
  return typeof value === 'string' ? value : ''
}

/**
 * Returns validated env. In development, logs missing keys; does not throw to avoid breaking build.
 */
export function getValidatedEnv(): Env {
  const env = {} as Record<string, string>
  const missing: string[] = []

  for (const key of REQUIRED_ENV_KEYS) {
    const value = getEnv(key)
    env[key] = value
    if (!value.trim()) missing.push(key)
  }

  if (missing.length > 0 && import.meta.env.DEV) {
    console.warn(
      '[mediAI] Missing or empty Firebase env:',
      missing.join(', '),
      '– copy .env.example to .env and fill values.'
    )
  }

  return {
    VITE_FIREBASE_API_KEY: env.VITE_FIREBASE_API_KEY,
    VITE_FIREBASE_AUTH_DOMAIN: env.VITE_FIREBASE_AUTH_DOMAIN,
    VITE_FIREBASE_PROJECT_ID: env.VITE_FIREBASE_PROJECT_ID,
    VITE_FIREBASE_STORAGE_BUCKET: env.VITE_FIREBASE_STORAGE_BUCKET,
    VITE_FIREBASE_MESSAGING_SENDER_ID: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    VITE_FIREBASE_APP_ID: env.VITE_FIREBASE_APP_ID,
  }
}
